interface AgreementProductOptions {
  agreementProductOverwrite?: number;
  manualAgreementProduct?: number;
  partnerAgreement?: number;
  agreementProductFromDiscount: number;
}

export const getAgreementProduct = ({
  agreementProductOverwrite,
  manualAgreementProduct,
  partnerAgreement,
  agreementProductFromDiscount,
}: AgreementProductOptions): number =>
  agreementProductOverwrite ||
  manualAgreementProduct ||
  partnerAgreement ||
  agreementProductFromDiscount;
